/* import __COLOCATED_TEMPLATE__ from './escalation-rule-triggered.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */
import templateOnly from '@ember/component/template-only';
import { type StepArguments } from '.';
import type EscalationRuleTriggered from 'embercom/models/operator/visual-builder/step/escalation-rule-triggered';
import type EditorConfig from 'embercom/objects/visual-builder/configuration/editor';

interface Signature {
  Args: StepArguments<EscalationRuleTriggered> & {
    editorConfiguration: EditorConfig;
  };
  Element: HTMLDivElement;
}

const EscalationRuleTriggeredNodeItem = templateOnly<Signature>();
export default EscalationRuleTriggeredNodeItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::EscalationRuleTriggered': typeof EscalationRuleTriggeredNodeItem;
    'workflows/graph-editor/node-items/steps/escalation-rule-triggered': typeof EscalationRuleTriggeredNodeItem;
  }
}
